import { DataGrid } from "@serenity-is/corelib";
import "./script-init";
import { UserPreferenceStorage } from '@serenity-is/extensions';

DataGrid.defaultPersistanceStorage = new UserPreferenceStorage();